module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-row', {
    attrs: {
      "justify": "center"
    }
  }, [_c('v-dialog', {
    attrs: {
      "width": "700px"
    },
    on: {
      "input": function($event) {
        return _vm.$emit('input')
      }
    },
    model: {
      value: (_vm.value),
      callback: function($$v) {
        _vm.value = $$v
      },
      expression: "value"
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "grey lighten-2",
    attrs: {
      "primary-title": ""
    }
  }, [_c('span', {
    staticClass: "headline"
  }, [_vm._v(_vm._s(_vm.quoteData.id ? 'Edit' : 'Create') + " Quote")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-icon', {
    on: {
      "click": _vm.close
    }
  }, [_vm._v("close")])], 1), _vm._v(" "), _c('v-card-text', {
    staticStyle: {
      "padding": "30px 50px 0",
      "max-height": "600px",
      "overflow-y": "auto"
    }
  }, [_c('v-row', [_c('v-col', {
    staticClass: "pb-0",
    attrs: {
      "cols": "12",
      "md": "5",
      "sm": "12"
    }
  }, [_c('p', {
    staticClass: "title-1 form-label"
  }, [_vm._v("Sales Person : ")])]), _vm._v(" "), _c('v-col', {
    staticClass: "pb-0",
    attrs: {
      "cols": "12",
      "md": "7",
      "sm": "12"
    }
  }, [_c('v-select', {
    attrs: {
      "items": _vm.saleUsers,
      "item-text": "firstName",
      "item-value": "id",
      "dense": "",
      "outlined": "",
      "error-messages": _vm.salePersonErrors
    },
    on: {
      "blur": function($event) {
        return _vm.$v.quoteData.salePerson.$touch()
      }
    },
    model: {
      value: (_vm.quoteData.salePerson),
      callback: function($$v) {
        _vm.$set(_vm.quoteData, "salePerson", $$v)
      },
      expression: "quoteData.salePerson"
    }
  })], 1)], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
    staticClass: "pb-0",
    attrs: {
      "cols": "12",
      "md": "5",
      "sm": "12"
    }
  }, [_c('p', {
    staticClass: "title-1 form-label"
  }, [_vm._v("Billing Name as per Xero : ")])]), _vm._v(" "), _c('v-col', {
    staticClass: "pb-0",
    attrs: {
      "cols": "12",
      "md": "7",
      "sm": "12"
    }
  }, [_c('v-autocomplete', {
    attrs: {
      "items": _vm.xeroContacts,
      "item-text": "Name",
      "attach": "",
      "dense": "",
      "outlined": "",
      "return-object": ""
    },
    model: {
      value: (_vm.quoteData.billingContact),
      callback: function($$v) {
        _vm.$set(_vm.quoteData, "billingContact", $$v)
      },
      expression: "quoteData.billingContact"
    }
  })], 1)], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
    staticClass: "pb-0",
    attrs: {
      "cols": "12",
      "md": "5",
      "sm": "12"
    }
  }, [_c('p', {
    staticClass: "title-1 form-label"
  }, [_vm._v("Quote No : ")])]), _vm._v(" "), _c('v-col', {
    staticClass: "pb-0",
    attrs: {
      "cols": "12",
      "md": "7",
      "sm": "12"
    }
  }, [_c('v-text-field', _vm._g({
    attrs: {
      "prefix": "IO-",
      "dense": "",
      "outlined": "",
      "error-messages": _vm.quoteNoErrors
    },
    on: {
      "blur": function($event) {
        return _vm.$v.quoteData.quoteNo.$touch()
      }
    },
    model: {
      value: (_vm.quoteData.quoteNo),
      callback: function($$v) {
        _vm.$set(_vm.quoteData, "quoteNo", $$v)
      },
      expression: "quoteData.quoteNo"
    }
  }, _vm.on))], 1)], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
    staticClass: "pb-0",
    attrs: {
      "cols": "12",
      "md": "5",
      "sm": "12"
    }
  }, [_c('p', {
    staticClass: "title-1 form-label"
  }, [_vm._v("Quote Acceptance Date (DD/MM/YYYY) : ")])]), _vm._v(" "), _c('v-col', {
    staticClass: "pb-0",
    attrs: {
      "cols": "12",
      "md": "7",
      "sm": "12"
    }
  }, [_c('v-text-field', _vm._g({
    attrs: {
      "dense": "",
      "outlined": "",
      "error-messages": _vm.acceptanceDateErrors
    },
    on: {
      "input": _vm.changeQuoteDate,
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.changeQuoteDate.apply(null, arguments)
      },
      "blur": function($event) {
        return _vm.$v.quoteData.acceptanceDate.$touch()
      }
    },
    model: {
      value: (_vm.quoteData.acceptanceDate),
      callback: function($$v) {
        _vm.$set(_vm.quoteData, "acceptanceDate", $$v)
      },
      expression: "quoteData.acceptanceDate"
    }
  }, _vm.on)), _vm._v(" "), (_vm.isInvalidQuoteDate) ? _c('p', {
    staticClass: "custom-danger ma-0 pt-1",
    staticStyle: {
      "margin-top": "-30px!important"
    }
  }, [_vm._v("Invalid Quote Date")]) : _vm._e()], 1)], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
    staticClass: "pb-0",
    attrs: {
      "cols": "12",
      "md": "5",
      "sm": "12"
    }
  }, [_c('p', {
    staticClass: "title-1 form-label"
  }, [_vm._v("Currency : ")])]), _vm._v(" "), _c('v-col', {
    staticClass: "pb-0",
    attrs: {
      "cols": "12",
      "md": "7",
      "sm": "12"
    }
  }, [_c('v-select', {
    attrs: {
      "items": _vm.currencyLists,
      "dense": "",
      "outlined": ""
    },
    model: {
      value: (_vm.quoteData.currency),
      callback: function($$v) {
        _vm.$set(_vm.quoteData, "currency", $$v)
      },
      expression: "quoteData.currency"
    }
  })], 1)], 1), _vm._v(" "), (_vm.isOtherCurrency) ? _c('v-row', [_c('v-col', {
    staticClass: "pb-0",
    attrs: {
      "cols": "12",
      "md": "5",
      "sm": "12"
    }
  }, [_c('p', {
    staticClass: "title-1 form-label"
  }, [_vm._v("Quote Amt FC : ")])]), _vm._v(" "), _c('v-col', {
    staticClass: "pb-0",
    attrs: {
      "cols": "12",
      "md": "7",
      "sm": "12"
    }
  }, [_c('v-text-field', {
    attrs: {
      "type": "number",
      "placeholder": "",
      "prefix": "$",
      "outlined": "",
      "dense": ""
    },
    on: {
      "blur": _vm.calcExgAmt
    },
    model: {
      value: (_vm.quoteData.quoteAmtFC),
      callback: function($$v) {
        _vm.$set(_vm.quoteData, "quoteAmtFC", $$v)
      },
      expression: "quoteData.quoteAmtFC"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.isOtherCurrency) ? _c('v-row', [_c('v-col', {
    staticClass: "pb-0",
    attrs: {
      "cols": "12",
      "md": "5",
      "sm": "12"
    }
  }, [_c('p', {
    staticClass: "title-1 form-label"
  }, [_vm._v("Est Exchange Rate : ")])]), _vm._v(" "), _c('v-col', {
    staticClass: "pb-0",
    attrs: {
      "cols": "12",
      "md": "7",
      "sm": "12"
    }
  }, [_c('v-text-field', {
    attrs: {
      "type": "number",
      "placeholder": "",
      "prefix": "$",
      "outlined": "",
      "dense": ""
    },
    on: {
      "blur": _vm.calcExgAmt
    },
    model: {
      value: (_vm.quoteData.estExchangeRate),
      callback: function($$v) {
        _vm.$set(_vm.quoteData, "estExchangeRate", $$v)
      },
      expression: "quoteData.estExchangeRate"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.isOtherCurrency) ? _c('v-row', [_c('v-col', {
    staticClass: "pb-0",
    attrs: {
      "cols": "12",
      "md": "5",
      "sm": "12"
    }
  }, [_c('p', {
    staticClass: "title-1 form-label"
  }, [_vm._v("Confirm Exchange Rate : ")])]), _vm._v(" "), _c('v-col', {
    staticClass: "pb-0",
    attrs: {
      "cols": "12",
      "md": "7",
      "sm": "12"
    }
  }, [_c('v-text-field', {
    attrs: {
      "type": "number",
      "placeholder": "",
      "prefix": "$",
      "outlined": "",
      "dense": ""
    },
    on: {
      "blur": _vm.calcExgAmt
    },
    model: {
      value: (_vm.quoteData.confirmExchangeRate),
      callback: function($$v) {
        _vm.$set(_vm.quoteData, "confirmExchangeRate", $$v)
      },
      expression: "quoteData.confirmExchangeRate"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.isOtherCurrency) ? _c('v-row', [_c('v-col', {
    staticClass: "pb-0",
    attrs: {
      "cols": "12",
      "md": "5",
      "sm": "12"
    }
  }, [_c('p', {
    staticClass: "title-1 form-label"
  }, [_vm._v("Display Rate : ")])]), _vm._v(" "), _c('v-col', {
    staticClass: "pb-0",
    attrs: {
      "cols": "12",
      "md": "7",
      "sm": "12"
    }
  }, [_c('v-radio-group', {
    staticClass: "mt-0",
    attrs: {
      "row": ""
    },
    on: {
      "change": _vm.calcExgAmt
    },
    model: {
      value: (_vm.quoteData.priceRdo),
      callback: function($$v) {
        _vm.$set(_vm.quoteData, "priceRdo", $$v)
      },
      expression: "quoteData.priceRdo"
    }
  }, [_c('div', [_c('v-radio', {
    staticClass: "pt-1",
    attrs: {
      "label": "Est Rate",
      "color": "warning",
      "value": 1
    }
  })], 1), _vm._v(" "), _c('div', [_c('v-radio', {
    staticClass: "pt-1",
    attrs: {
      "label": "Confirm Rate",
      "color": "warning",
      "value": 2
    }
  })], 1)]), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "type": "number",
      "placeholder": "",
      "prefix": "$",
      "outlined": "",
      "dense": ""
    },
    model: {
      value: (_vm.calculatedRate),
      callback: function($$v) {
        _vm.calculatedRate = $$v
      },
      expression: "calculatedRate"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), _c('v-row', [_c('v-col', {
    staticClass: "pb-0",
    attrs: {
      "cols": "12",
      "md": "5",
      "sm": "12"
    }
  }, [_c('p', {
    staticClass: "title-1 form-label"
  }, [_vm._v("Quote Amt (excl. GST) : ")])]), _vm._v(" "), _c('v-col', {
    staticClass: "pb-0",
    attrs: {
      "cols": "12",
      "md": "7",
      "sm": "12"
    }
  }, [_c('v-text-field', {
    attrs: {
      "type": "number",
      "placeholder": "",
      "prefix": "$",
      "outlined": "",
      "dense": "",
      "error-messages": _vm.quoteAmtErrors
    },
    on: {
      "blur": function($event) {
        return _vm.$v.quoteData.quoteAmt.$touch()
      }
    },
    model: {
      value: (_vm.quoteData.quoteAmt),
      callback: function($$v) {
        _vm.$set(_vm.quoteData, "quoteAmt", $$v)
      },
      expression: "quoteData.quoteAmt"
    }
  })], 1)], 1), _vm._v(" "), (_vm.quoteData.id) ? _c('v-row', [_c('v-col', {
    staticClass: "pb-0",
    attrs: {
      "cols": "12",
      "md": "5",
      "sm": "12"
    }
  }, [_c('p', {
    staticClass: "title-1 form-label"
  }, [_vm._v("Invoice Created on Xero: ")])]), _vm._v(" "), _c('v-col', {
    staticClass: "pb-0",
    attrs: {
      "cols": "12",
      "md": "7",
      "sm": "12"
    }
  }, [_c('v-text-field', {
    attrs: {
      "type": "number",
      "placeholder": "",
      "prefix": "$",
      "outlined": "",
      "dense": ""
    },
    on: {
      "change": _vm.changeInvoiceSent
    },
    model: {
      value: (_vm.quoteData.invoiceCreated),
      callback: function($$v) {
        _vm.$set(_vm.quoteData, "invoiceCreated", $$v)
      },
      expression: "quoteData.invoiceCreated"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.quoteData.id) ? _c('v-row', [_c('v-col', {
    staticClass: "pb-0",
    attrs: {
      "cols": "12",
      "md": "5",
      "sm": "12"
    }
  }, [_c('p', {
    staticClass: "title-1 form-label"
  }, [_vm._v("Invoice Sent: ")])]), _vm._v(" "), _c('v-col', {
    staticClass: "pb-0",
    attrs: {
      "cols": "12",
      "md": "7",
      "sm": "12"
    }
  }, [(_vm.quoteData.activity && _vm.quoteData.activity.length) ? _c('div', _vm._l((_vm.quoteData.activity), function(activity, index) {
    return _c('div', {
      key: index,
      staticClass: "d-flex flex-row mb-2"
    }, [_c('v-text-field', {
      attrs: {
        "type": "number",
        "placeholder": "",
        "prefix": "$",
        "outlined": "",
        "disabled": "",
        "dense": "",
        "hide-details": ""
      },
      model: {
        value: (activity.amount),
        callback: function($$v) {
          _vm.$set(activity, "amount", $$v)
        },
        expression: "activity.amount"
      }
    })], 1)
  }), 0) : _vm._e(), _vm._v(" "), (_vm.quoteData.id) ? _c('div', {
    staticClass: "mt-1"
  }, [_c('v-btn', {
    staticClass: "btn-invoice-sent-edit ml-0",
    attrs: {
      "color": "warning",
      "small": ""
    },
    on: {
      "click": _vm.openInvoiceSentEditDialog
    }
  }, [_c('v-icon', {
    attrs: {
      "color": "white",
      "title": "Add Invoice Sent",
      "small": ""
    }
  }, [_vm._v("mdi-plus")]), _vm._v(" Add\n              ")], 1), _vm._v(" "), (_vm.quoteData.id) ? _c('v-btn', {
    staticClass: "btn-invoice-sent-edit",
    attrs: {
      "color": "warning",
      "small": ""
    },
    on: {
      "click": function($event) {
        return _vm.openInvoiceSentActivityDialog(_vm.quoteData.activity)
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "color": "white",
      "title": "View Details",
      "small": ""
    }
  }, [_vm._v("remove_red_eye")]), _vm._v(" View\n              ")], 1) : _vm._e()], 1) : _vm._e()])], 1) : _vm._e(), _vm._v(" "), (_vm.quoteData.id) ? _c('v-row', [_c('v-col', {
    staticClass: "pb-0",
    attrs: {
      "cols": "12",
      "md": "5",
      "sm": "12"
    }
  }, [_c('p', {
    staticClass: "title-1 form-label"
  }, [_vm._v("Yet to Invoice: ")])]), _vm._v(" "), _c('v-col', {
    staticClass: "pb-0",
    attrs: {
      "cols": "12",
      "md": "7",
      "sm": "12"
    }
  }, [_c('v-text-field', {
    attrs: {
      "type": "number",
      "placeholder": "",
      "prefix": "$",
      "disabled": "",
      "outlined": "",
      "dense": ""
    },
    model: {
      value: (_vm.quoteData.invoicePending),
      callback: function($$v) {
        _vm.$set(_vm.quoteData, "invoicePending", $$v)
      },
      expression: "quoteData.invoicePending"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.quoteData.id) ? _c('v-row', [_c('h4', {
    staticClass: "pl-2 mb-0",
    staticStyle: {
      "font-weight": "bold"
    }
  }, [_vm._v("Timelines")]), _vm._v(" "), _c('v-col', {
    staticClass: "pb-0",
    attrs: {
      "cols": "12",
      "md": "12",
      "sm": "12"
    }
  }, [_c('v-btn', {
    staticClass: "ml-0",
    attrs: {
      "color": "warning",
      "small": ""
    },
    on: {
      "click": _vm.openTimelineUpdateDialog
    }
  }, [_c('v-icon', {
    attrs: {
      "color": "white",
      "title": "Add Invoice Sent",
      "small": ""
    }
  }, [_vm._v("mdi-plus")]), _vm._v(" Add\n            ")], 1)], 1), _vm._v(" "), _c('v-col', {
    staticClass: "pb-0",
    attrs: {
      "cols": "12",
      "md": "12",
      "sm": "12"
    }
  }, [_c('v-simple-table', {
    scopedSlots: _vm._u([{
      key: "default",
      fn: function() {
        return [_c('thead', [_c('tr', [_c('th', {
          staticClass: "text-left"
        }, [_vm._v("Amount")]), _vm._v(" "), _c('th', {
          staticClass: "text-left"
        }, [_vm._v("Start Month")]), _vm._v(" "), _c('th', {
          staticClass: "text-left"
        }, [_vm._v("End Month")]), _vm._v(" "), _c('th', {
          staticClass: "text-left"
        }, [_vm._v("Status")]), _vm._v(" "), _c('th', {
          staticClass: "text-left"
        }, [_vm._v("Remark")]), _vm._v(" "), _c('th', {
          staticClass: "text-left"
        }, [_vm._v("Action")])])]), _vm._v(" "), _c('tbody', [(!_vm.quoteData.quoteData.length) ? _c('tr', [_c('td', {
          attrs: {
            "colspan": "4"
          }
        }, [_vm._v("Empty List")])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.quoteData.quoteData), function(item, index) {
          return _c('tr', {
            key: index
          }, [_c('td', [_vm._v("$" + _vm._s(_vm._f("thousandSeprator")(item.quoteAmt)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.formatMonth(item.startMonth)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.formatMonth(item.endMonth)))]), _vm._v(" "), _c('td', [(item.status === _vm.quoteStatuses.ACCEPT) ? _c('span', [_vm._v("Approved")]) : (item.status === _vm.quoteStatuses.REJECT) ? _c('span', [_vm._v("Rejected")]) : _c('span', [_vm._v("Pending")])]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.remarks || ''))]), _vm._v(" "), _c('td', [(item.status === _vm.quoteStatuses.ACCEPT) ? _c('div', {
            staticClass: "ma-1"
          }, [_c('div', [_c('v-btn', {
            staticClass: "ml-0",
            attrs: {
              "color": "warning",
              "small": ""
            },
            on: {
              "click": function($event) {
                return _vm.openTimelineUpdateDialogForEdit(item, index)
              }
            }
          }, [_c('v-icon', {
            attrs: {
              "x-small": ""
            }
          }, [_vm._v("edit")])], 1)], 1)]) : _vm._e(), _vm._v(" "), (item.status === _vm.quoteStatuses.ACCEPT) ? _c('div', {
            staticClass: "ma-1"
          }, [_c('div', [_c('v-btn', {
            staticClass: "ml-0",
            attrs: {
              "color": "red",
              "small": ""
            },
            on: {
              "click": function($event) {
                return _vm.deleteTimeline(index)
              }
            }
          }, [_c('v-icon', {
            staticStyle: {
              "color": "#fff"
            },
            attrs: {
              "x-small": ""
            }
          }, [_vm._v("mdi-delete-outline")])], 1)], 1)]) : _vm._e(), _vm._v(" "), (item.status === _vm.quoteStatuses.PENDING) ? _c('div', {
            staticClass: "mt-2"
          }, [_c('div', [_c('v-btn', {
            staticClass: "ml-0",
            staticStyle: {
              "width": "80px"
            },
            attrs: {
              "color": "green",
              "small": ""
            },
            on: {
              "click": function($event) {
                return _vm.processQuoteData(index, _vm.quoteStatuses.ACCEPT)
              }
            }
          }, [_vm._v("\n                            Approve\n                          ")])], 1), _vm._v(" "), _c('div', [_c('v-btn', {
            staticClass: "ml-0 mt-1",
            staticStyle: {
              "width": "80px"
            },
            attrs: {
              "color": "red",
              "small": ""
            },
            on: {
              "click": function($event) {
                return _vm.processQuoteData(index, _vm.quoteStatuses.REJECT)
              }
            }
          }, [_vm._v("\n                            Reject\n                          ")])], 1)]) : _vm._e()])])
        })], 2)]
      },
      proxy: true
    }], null, false, 3600264267)
  })], 1)], 1) : _vm._e()], 1), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "red darken-1",
      "text": ""
    },
    on: {
      "click": _vm.close
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "green darken-1",
      "disabled": _vm.disableMasterLists || _vm.invalidInvoiceSent || _vm.isInvalidQuoteDate,
      "text": ""
    },
    on: {
      "click": _vm.saveQuote
    }
  }, [_vm._v("Save")])], 1)], 1)], 1), _vm._v(" "), _c('loading', {
    attrs: {
      "active": _vm.isLoading,
      "can-cancel": false,
      "is-full-page": true,
      "loader": "bars",
      "background-color": "#000",
      "color": "secondary",
      "width.number": "180",
      "height.number": "180"
    },
    on: {
      "update:active": function($event) {
        _vm.isLoading = $event
      }
    }
  }), _vm._v(" "), _c('invoice-sent-edit-modal', {
    attrs: {
      "value": _vm.invoiceSentEditDialog,
      "data": _vm.quoteData
    },
    on: {
      "created": _vm.updatedInvoiceSent
    },
    model: {
      value: (_vm.invoiceSentEditDialog),
      callback: function($$v) {
        _vm.invoiceSentEditDialog = $$v
      },
      expression: "invoiceSentEditDialog"
    }
  }), _vm._v(" "), _c('invoice-sent-activity-modal', {
    attrs: {
      "value": _vm.invoiceSentActivityDialog,
      "data": _vm.editActivityData
    },
    on: {
      "updateActivityData": _vm.updateActivityData
    },
    model: {
      value: (_vm.invoiceSentActivityDialog),
      callback: function($$v) {
        _vm.invoiceSentActivityDialog = $$v
      },
      expression: "invoiceSentActivityDialog"
    }
  }), _vm._v(" "), _c('timeline-amount-update-modal', {
    attrs: {
      "value": _vm.timelineUpdateDialog,
      "data": _vm.quoteData,
      "editTimelineData": _vm.editTimelineData,
      "editTimelineIdx": _vm.editTimelineIdx
    },
    on: {
      "created": _vm.updateTimelineAmount
    },
    model: {
      value: (_vm.timelineUpdateDialog),
      callback: function($$v) {
        _vm.timelineUpdateDialog = $$v
      },
      expression: "timelineUpdateDialog"
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e0beb9d6"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/Campaign/MasterLists/CreateQuoteModal.vue
// module id = 2305
// module chunks = 0